import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","TermsAndConditionsPolicyDataId"] */ "/codebuild/output/src3212572533/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
